import './shared/styles/global.scss';
import './shared/polyfill';
import './shared/sentry';
import './shared/googleAnalytics';
import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyles } from '@spotify-internal/creator-tape';
import { BrowserRouter } from 'react-router-dom';
import { App, AppLoading, AppError } from './app';

const mount =
  process.env.NODE_ENV === 'production' ? ReactDOM.hydrate : ReactDOM.render;

mount(
  <>
    <GlobalStyles noFonts />
    <AppError>
      <React.Suspense fallback={<AppLoading />}>
        <BrowserRouter basename="/c">
          <App />
        </BrowserRouter>
      </React.Suspense>
    </AppError>
  </>,
  document.getElementById('root'),
);
